module.exports = __webpack_public_path__ + "static/media/daclab.43e983ce.jpg";